export const routerAddress = "0xC6eD3Fd9a0F28145a4Fcb01EbbDC6e98AA856809";
export const factoryAddress = "0x6445d7FbD81Db1Ae882C9EF23bed0214523E9E79";
export const WETHAddress = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
// DAI : 0xF843A6521E8793c80e29677DB92d895d5Fd85479
